import Event from './Event';
import Events from './Events';

export default class BlurEvent extends Event {
    public data: FocusEvent;

    constructor(data: FocusEvent) {
        super(Events.Blur);
        this.data = data;
    }
}
